@if (reactions.length > 0 || !isDeleted) {
<div class="reactions" [class.center-narrow]="shouldCenterNarrow">
  <div class="reaction-list">
    @for (r of visibleReactions; track r.emoji) {
    <button
      class="reaction-chip"
      (click)="onReactionChipClick(r.emoji)"
      (mouseenter)="onReactionChipEnter(r.emoji)"
      (mouseleave)="onReactionChipLeave()"
      [class.reacted]="r.currentUserReacted"
      [class.show-tooltip]="tooltipVisibleForEmoji === r.emoji"
    >
      <span class="emoji-wrapper">
        @if (r.emoji === '✅') {
        <svg
          class="emoji-svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          aria-label="Erledigt"
          role="img"
          focusable="false"
        >
          <circle cx="12" cy="12" r="10" fill="#22C55E" />
          <path
            d="M9.5 12.5l2 2 4-4"
            stroke="#FFFFFF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill="none"
          />
        </svg>
        } @else {
        <span class="emoji">{{ r.emoji }}</span>
        } @if (!r.isLegacyCount) {
        <div class="reaction-tooltip">
          <div class="reacter-emoji">
            @if (r.emoji === '✅') {
            <img src="assets/icons/check-green.svg" alt="Erledigt" class="emoji-svg" />
            } @else {
            <span>{{ r.emoji }}</span>
            }
          </div>
          <div class="reacter-names">
            @for (uid of r.userIds; track uid; let i = $index) {
            <span>{{ r.userNames[i] || '...' }}</span
            >@if (i < r.userIds.length - 1) {<span>,&nbsp;</span>} }
          </div>
          <div class="reacter-verb">
            {{ r.count === 1 ? 'hat reagiert' : 'haben reagiert' }}
          </div>
        </div>
        }
      </span>
      @if (r.count > 1) { <span class="count-number">{{ r.count }}</span> } @else if (r.count === 1)
      { <span class="count-number">1</span> }
    </button>
    } @if (!reactionsExpanded && hasMore) {
    <button class="reaction-chip more-chip" (click)="showMore()">+ {{ moreCount }} weitere</button>
    } @if (reactionsExpanded && hasMore) {
    <button class="reaction-chip less-chip" (click)="showLess()">weniger anzeigen</button>
    }
    <div class="reaction-trigger">
      <img
        src="assets/icons/add_reaction.svg"
        alt="Add reaction"
        class="add-reaction-icon icon-btn"
        (click)="isDeleted ? null : onAddReactionClick(); $event.stopPropagation()"
      />
      <app-emoji-picker-component
        [showEmojiPicker]="showEmojiPicker"
        (emojiSelected)="onEmojiSelected($event)"
        (closePicker)="onCloseEmojiPicker()"
      ></app-emoji-picker-component>
    </div>
  </div>
</div>
}
